import React from "react";
import { Checkbox, Switch } from "@shape-ds/components";
import { useFeatureFlagManager } from "../FeatureFlag.context";
export const AB_TEST_VARIANT_A = "variant-a";
export const AB_TEST_VARIANT_B = "variant-b";

export const FeatureFlagsAbTests: React.FC<{
  flagKey: string;
  enabled: boolean;
  variant: string;
}> = ({ flagKey, enabled, variant }) => {
  const { setTestAbVariant } = useFeatureFlagManager();

  return (
    <div className="ff-test-item">
      <Checkbox
        label={flagKey}
        checked={enabled}
        onChange={(_, checked) =>
          setTestAbVariant(flagKey, checked, checked ? AB_TEST_VARIANT_A : "")
        }
      />
      <span>
        <Switch
          label={"variant A"}
          labelPosition="start"
          checked={variant === AB_TEST_VARIANT_B}
          onChange={(_, checked) => {
            setTestAbVariant(
              flagKey,
              enabled,
              checked ? AB_TEST_VARIANT_B : AB_TEST_VARIANT_A
            );
          }}
        />
        variant B
      </span>
    </div>
  );
};
